import classNames from '@/external/classNames';

type Props = {
  className?: string;
};

const Header: FC<Props> = ({ children, className }) => (
  <header
    className={classNames(
      'bg-goku top-0 sticky z-20 md:z-10 flex h-16 md:rem:h-[88px] px-5 -mx-5',
      className,
    )}
  >
    {children}
  </header>
);

export default Header;
